
import React, { useState, useRef, useContext, useEffect } from 'react';
import { Transition } from 'react-transition-group';
import { iAeonOpenBrowser } from '../../library/iaeon_sdk.js';

//お買物API
import { callOkaimonoAPI } from "../../components/okaimonoAPI";

import styles from '../../styles/Policy.module.scss'

export function Policy(props) {


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.remove('is_behind');

	//お買物API：画面遷移API（利用規約
	props.okaimonoAPI_didScreenTransition("policy");

	document.body.classList.add('is_scroll');
	return () => {
		document.body.classList.remove('is_scroll');
	};
}, []);


//----------------------------------------
// iAEON API：25.外部ブラウザOpenAPI
//----------------------------------------

function callAPI_25(surl){
    let successCall_25 = function(success){
		// alert("【iAeonOpenBrowser】success");
        var aaa = success;
		console.log('【iAeonOpenBrowser】success：' + aaa);

    }
    let errorCall_25 = function(error){
		// alert("【iAeonOpenBrowser】error: " + error);
		var bbb = error;
		console.log('【iAeonOpenBrowser】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonOpenBrowser】call');
    iAeonOpenBrowser({"url":surl}).then(successCall_25).catch(errorCall_25);
}


//----------------------------------------
//お買物API：外部ブラウザOpenAPI（ポリシー同意 << 25.外部ブラウザOpenAPI
//----------------------------------------

const okaimonoAPI_openBrowser = async (surl) => {
	try {
		console.log("----------------------------");
		console.log("【didTapExternalBrowserUrl】call");
		const { callbackId, result } = await callOkaimonoAPI('didTapExternalBrowserUrl', { url: surl });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【didTapExternalBrowserUrl】success", result);
			console.log("【didTapExternalBrowserUrl】result:", result.result);

		}else {
			console.log("【didTapExternalBrowserUrl】error", result);
			console.log("【didTapExternalBrowserUrl】result:", result.result);
			console.log("【didTapExternalBrowserUrl】code:", result.error.code);
			console.log("【didTapExternalBrowserUrl】message:", result.error.message);
			props.setErrFlg(true);
			var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			props.setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【didTapExternalBrowserUrl】error', error);
		props.setErrFlg(true);
		props.setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


return (
	<>

	<div className={styles.policyBlock}>
		<div className={styles.policyBox}>
			<h2 className={styles.policyBox_title}>「イオンお買物アプリレジゴーミニアプリ」利用規約</h2>
			<p className={styles.policy_txt}>イオンリテール株式会社（以下、「当社」といいます。）は、当社が運営するイオンお買物アプリレジゴーミニアプリ（以下、「本アプリ」といいます）の利用について、以下のとおり本規約を定めます。</p>

			<h2 className={styles.policyBox_tit_l}>第1条（利用者条件等）</h2>
			<ol>
				<li>本規約は、第2条に定めるサービス（以下、「本サービス」といいます。）の提供を希望して自己の端末にイオンお買物アプリをダウンロードし、イオンお買物アプリの会員登録をして本アプリを利用する者（以下、「利用者」といいます。）に適用されます。</li>
				<li>本サービスの利用にかかる通信費用は、利用者が負担するものとします。</li>
				<li>利用者が使用する端末、ソフトウェアおよび通信環境が本アプリの利用に適さない場合であっても、当社は本アプリの変更・改善等を行う義務を負わないものとします。</li>
				<li>利用者が未成年の場合、利用者は、本アプリを使用するために保護者の同意を得なければなりません。未成年の利用者が本アプリを使用した場合、保護者の同意があったものとみなされます。</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第2条（本サービス）</h2>
			<ol>
				<li>本サービスの内容は次のとおりとします。
					<ol className={styles.round_number}>
						<li>本サービスは、本アプリを通じて、利用者が商品のバーコードを読み取り、または商品リストから商品登録をすることで、商品の売価情報や販促情報を参照、購入代金を計算しレジゴー専用レジにてお会計を行うことができる機能（以下、「レジゴーシステム」といいます。）を提供します。</li>
						<li>本サービスは、医薬品、酒・たばこその他の購入に年齢制限などがある商品その他の法令、または店舗にて制限する商品を購入することができないこと、またはそれらを購入するために従業員による確認が必要な場合がございます。</li>
						<li>本サービスは、レジゴーシステムを利用して商品の代金を支払った後に、本アプリ内で当該支払金額を変更または取消す機能を提供しておりません。当該支払の変更または取消しを行う場合は、利用者は、ご利用店舗にて購入した商品とそのレシートを従業員に提示の上対応を受けるものとします。その際、利用者が購入した商品とレシートを店舗に持参されない場合は原則として対応を受けることができません。
						</li>
						<li>当社およびイオングループ企業またはその他当社の指定する企業の商品・サービ
							スに関する次の情報等のご提供をいたします。
							<ul className={styles.kana}>
								<li>セールス、イベント、キャンペーンに関する情報</li>
								<li>新商品、おすすめ商品および各種サービスに関する情報</li>
								<li>お得情報</li>
							</ul>
						</li>
						<li>利用者の購買状況に応じた店舗別の情報やクーポン等のご提供をいたします。</li>
					</ol>
				</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第3条（規約の範囲および変更）</h2>
			<ol>
				<li>当社が本アプリ上における掲示またはその他の方法により規定する個別規定は、本規約の一部を構成します。本規約と個別規定が異なる場合には個別規定が優先するものとします。</li>
				<li>当社は、次のいずれかに該当する場合には、利用者の承諾なく、当社の独自の判断により、本規約を変更することがあります。当該変更された利用条件ないし本サービスの内容は、イオンお買物アプリ上に掲示またはその他当社が適当と認めるその他の方法により通知した時点より効力を発するものとします。
					<ol className={styles.round_number}>
						<li>変更の内容が利用者の一般の利益に適合するとき。</li>
						<li>変更の内容が本規約にかかる取引の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。</li>
					</ol>
				</li>
				<li>本規約の変更に伴い、利用者に不利益、損害が発生した場合については、第12条の定めるところによるものとします。</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第4条（利用者の地位および禁止事項）</h2>
			<ol>
				<li>利用者の地位<br/>
					利用者は、自己の端末にイオンお買物アプリをダウンロードし、イオンお買物アプリの会員登録をして本アプリを利用することをもって、本規約に同意したものとみなされ、同時に本アプリを利用できる地位を得るものとします。
					</li>
				<li>利用者に対する禁止事項<br/>
					利用者は、以下に掲げる行為は行ってはならないものとします。
					<ol className={styles.round_number}>
						<li>第三者もしくは当社の財産もしくはプライバシー等を侵害する行為または侵害する恐れのある行為。</li>
						<li>第三者もしくは当社に不利益もしくは損害を与える行為またはその恐れのある行為。</li>
						<li>本アプリの運営を妨害する行為。</li>
						<li>公序良俗に反する行為。</li>
						<li>本サービスのネットワークまたはシステム等に過度な負荷をかける行為。</li>
						<li>反社会的勢力に対する利益供与その他の協力行為。</li>
						<li>犯罪行為もしくは犯罪行為に結びつく行為またはその恐れのある行為。</li>
						<li>虚偽の申告、届出を行なう行為。</li>
						<li>第三者もしくは当社の名誉もしくは信用を毀損する行為。</li>
						<li>コンピュータウィルス等有害なプログラムを使用もしくは提供する行為またはその恐れのある行為。</li>
						<li>当社が指定する方法によるものを除き、情報収集ボット、ロボット、スパイダー、スクレイパーその他の技術的手段を使用して、自ら本サービスから情報取得、編集、もしくは利用（以下、「情報取得等」といいます。）することまたは第三者に情報取得等させること。</li>
						<li>国内外の法令に違反する行為またはその恐れのある行為。</li>
						<li>その他当社が不適切と判断する行為。</li>
					</ol>
				</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第5条（本アプリに掲載する情報）</h2>
			<p className={styles.policy_txt}>当社は、本アプリに掲載する情報の正確性、最新性、有用性等その他一切の事項について、いかなる保証もするものではありません。また、当社は、利用者に事前に通知することなく、当社の判断によって本アプリで公開されている情報の追加、変更、修正、削除を行う場合があります。本アプリの情報の追加、変更、修正、削除等により利用者または第三者に生じた損害については、第12条の定めるところによるものとします。</p>

			<h2 className={styles.policyBox_tit_l}>第6条（本サービスの中断、停止）</h2>
			<ol>
				<li>当社は、以下のいずれかの事由に該当する場合、当社の独自の判断により、利用者に事前に通知することなく本サービスの一部もしくは全部の一時中断または停止をすることがあります。
					<ol className={styles.round_number}>
						<li>本アプリ公開または本サービス提供のための装置、システムの保守点検、更新を定期的または緊急に行う場合。</li>
						<li>火災、停電、天災などの不可抗力により、本アプリの公開が困難な場合。</li>
						<li>電気通信事業者の電気通信サービスが提供されない場合。</li>
						<li>その他、運用上あるいは技術上、当社が本アプリの公開を一時中断もしくは停止する必要があると判断した場合または不測の事態により、本アプリの公開が困難と判断した場合。</li>
					</ol>
				</li>
				<li>当社は、本アプリを一時中断、停止等したことにより、利用者または第三者が被ったいかなる不利益、損害については第12条の定めるところによるものとします。</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第7条（利用終了、利用停止等）</h2>
			<ol>
				<li>利用者は、自己の端末にインストールされているイオンお買物アプリから退会し、自己の端末からイオンお買物アプリをアンインストール（削除）することにより、本アプリの利用を終了することができます。</li>
				<li>利用者が、前項の方法により本アプリの利用を終了したとしても、本アプリ上で当社が取得した利用者の情報が削除されるわけではありません。当該利用者情報の取扱いについては第14条の定めるところによるものとします。</li>
				<li>利用者が本規約に違反した場合、当社は、当該利用者への通知なく、本サービスの提供を停止、または本アプリの操作を制限することができます。これらの措置により、利用者に不利益、損害が発生した場合、当社はその責任を一切負わないものとします。</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第8条（ログ情報）</h2>
			<ol>
				<li>当社は、利用者が本アプリを利用する際、アクセス日時、イオンお買物アプリ会員番号及びイオン共通ID 、端末の位置情報、端末識別子、端末の機種名、端末のOS バージョン、お気に入り店舗、広告識別子、商品のスキャン情報、購買履歴をログ情報として記録します。</li>
				<li>当社は利用者のログ情報を以下の目的で利用します。
					<ol className={styles.round_number}>
						<li>本サービス提供にあたり、利用者ごとにカスタマイズされた使いやすいサービスを提供するため。</li>
						<li>当社が利用者に最適なコンテンツ、各種サービスの案内などを提供するため。</li>
						<li>位置情報により、本アプリへのチェックイン、来店などを条件としたキャンペーン、各種サービスを提供するため。</li>
						<li>本アプリおよび当社（イオングループ企業を含む）が提供するサービス・マーケティング活動を改善・充実させるためならびに新サービスを検討することを目的とする分析・抽出等を行うため。</li>
						<li>その他上記各利用目的に準ずるか、これらに密接に関連する目的。</li>
					</ol>
				</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第9条（リンクの扱い）</h2>
			<p className={styles.policy_txt}>本アプリから他のサイトへ接続をした場合、当社は本アプリ外のサイトについては、何ら責任は負いません。この場合、当該サイトに包括され、また当該サイト上で利用が可能となっているコンテンツ、広告、商品、サービスなどについても同様に一切責任を負いません。当社は、それらのコンテンツ、広告、商品、サービスなどに起因または関連して生じた一切の損害についても賠償する責任は負いません。</p>

			<h2 className={styles.policyBox_tit_l}>第10条（著作権）</h2>
			<ol>
				<li>利用者は、権利者の承諾を得ないで、いかなる方法においても本アプリを通じて提供されるいかなる情報も、著作権法で定める利用者個人の私的使用の範囲を超える複製、販売、出版、その他の用途に使用することはできないものとします。</li>
				<li>利用者は、権利者の承諾を得ないで、いかなる方法においても、第三者をして、本アプリを通じて提供されるいかなる情報も使用させたり、公開させたりすることはできないものとします。</li>
				<li>本条の規約に違反して第三者との間に問題が発生した場合、利用者は、自己の責任と費用において係る問題を解決するとともに、当社に何らの迷惑または損害を与えないものとします。</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第11条（商標）</h2>
			<p className={styles.policy_txt}>本アプリに掲載または使用されている商標、イオングループの開発商品の名称ならびに商品ロゴ等は、当社またはイオングループ企業の登録商標、商標です。その他の商品および会社等の名称は、一般に各社の商号、登録商標です。当社または各社の登録商標のご使用に際しては、当社または当該各社の書面による事前許諾が必要となります。</p>

			<h2 className={styles.policyBox_tit_l}>第12条（賠償責任）</h2>
			<p className={styles.policy_txt}>本アプリによる本サービスの変更、中断、中止、停止、もしくは廃止またはその他本アプリに関連して発生した利用者または第三者の損害について、当社は一切の責任を負わないものとします。</p>

			<h2 className={styles.policyBox_tit_l}>第13条（免責）</h2>
			<ol>
				<li>当社は、利用者が当社により本アプリの利用を停止された場合、利用者に生じた損害について一切責任を負わないものとします。</li>
				<li>当社は、本アプリがすべての利用者の端末に対応することを保証しません。
					<ol className={styles.round_number}>
						<li>推奨のOSのバージョンであっても、端末によってはアプリが正常に動作しない場合があります。</li>
						<li>本アプリはスマートフォン用アプリとして開発しており、タブレット・パソコン等での動作保証はありません。</li>
						<li>本アプリは日本国内からのみご利用いただけます。国外からの通信及びVPN等による海外経由の通信の場合、ご利用いただけません。</li>
					</ol>
				</li>
				<li>当社は、本サービスの内容及び利用者が本アプリを通じて知り得る情報について、その完全性、正確性、確実性、有用性等に関して、いかなる責任も負いません。</li>
				<li>本アプリに掲載されている情報、画像及びリンク等を利用することにより、利用者の機器等に損害が生じた場合、また、ウィルス感染した場合等について、当社はいかなる責任も負いません。</li>
				<li>本アプリに掲載されている商品情報については正確性を期しておりますが、保証をするものではありません。</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第14条（個人情報等）</h2>
			<ol>
				<li>利用者は、当社が本サービスを提供する目的および本条第4項第3号の利用目的で個人情報および登録情報を利用することを承諾します。</li>
				<li>利用者は、当社およびイオングループ企業が前項の利用目的のために個人情報および登録情報並びに本アプリのアクセス情報、その他購買情報、支払情報等を保護措置を講じたうえで電磁的媒体物等の方法を用いて共同利用をすることに同意します。</li>
				<li>利用者は、利用者自身が当該情報を正確に入力しなかった場合は当社およびイオングループ企業からのご連絡や本サービスの提供等が正常に行うことができない場合があることをあらかじめ了承します。</li>
				<li>本サービスにおいて利用者からご提供いただく情報等については、以下の通りとします。
					<ol className={styles.round_number}>
						<li>情報を取得する者の名称<br/>
							イオンリテール株式会社</li>
						<li>個人情報保護管理者（若しくはその代理人）の所属および連絡先<br/>
							イオンリテール株式会社<br/>
							イオンお買物アプリ運営事務局<br/>
							連絡先：0120-001-219</li>
						<li>取得される情報の項目<br/>
							利用者の取得される情報
							<ul className={styles.list}>
								<li>イオンお買物アプリ会員番号及びイオン共通ID</li>
								<li>端末の位置情報</li>
								<li>端末識別子(Android、iOS)</li>
								<li>端末の機種名</li>
								<li>端末のOSバージョン</li>
								<li>お気に入り店舗</li>
								<li>広告識別子</li>
								<li>商品のスキャン情報</li>
								<li>購買履歴</li>
								<li>本サービスへのアクセスログ</li>
							</ul>
						</li>
						<li>利用目的
							<ul className={styles.list}>
								<li>本サービスの提供</li>
								<li>利用者への通知</li>
								<li>利用者の認証</li>
								<li>広告効果の測定等のマーケティング調査、統計、分析</li>
								<li>商品および接客等のサービス品質の改善・向上</li>
								<li>利用者に対する各種商品、サービスの提案・情報提供・広告配信</li>
							</ul>
							<ul className={styles.list}>
								例として以下の利用が含まれます。
							</ul>
							<ul className={styles.list}>
								<li>当社が実施するキャンペーンのご案内</li>
								<li>当社のサービスに関するメールマガジン、お知らせ及び広告等の情報提供</li>
								<li>当社が適切と判断した企業の情報提供</li>
								<li>Google、X、Facebook、LINE、Yahooその他の広告関連事業者を利用したターゲティング広告の配信</li>
							</ul>
							<ul className={styles.list}>※広告関連事業者が保有する各ユーザーリストとメールアドレス・広告識別子の情報を紐付けて、当該広告関連事業者が提供するサービスを利用するお客さまを特定して当該サービス上で各種サービスの提案・情報提供・広告配信を行う場合があります。</ul>
						</li>
					</ol>
				</li>
				<li>共同利用<br/>
					当社は、以下のとおり登録いただいた情報をイオングループ企業との間で、共同利用します。
					<ol className={styles.round_number}>
						<li>共同利用する個人データの項目<br/>
							利用者の情報：イオン共通ID、お気に入り店舗、購買履歴、本サービスへのアクセスログ、端末の位置情報、端末の機種名、端末のOSバージョン</li>
						<li>共同して利用する者の範囲<br/>
							下記の会社と共同利用いたします。<br/>
							（共同して利用する者）
							<ul className={styles.list}>
								<li>イオン東北株式会社</li>
								<li>イオン九州株式会社</li>
								<li>株式会社ダイエー</li>
								<li>イオン琉球株式会社</li>
								<li>イオンスマートテクノロジー株式会社</li>
							</ul>
						</li>
						<li>共同利用する者の利用目的<br/>
							前項4号記載の利用目的と同じです。</li>
						<li>当該個人データの管理について責任を有する者の名称<br/>
							イオンリテール株式会社 代表取締役社長 古澤 康之<br/>
							住所：千葉県千葉市美浜区中瀬一丁目5番地1</li>
						<li>共同利用するデータの取得方法<br/>
							共同利用する個人データは、本アプリを通じて取得したものとします。</li>
					</ol>
				</li>
				<li>当社は、厳正な管理のもと、本サービスを提供する目的のため必要最小限の範囲で個人情報の取扱いを外部業者等に委託する場合があります。</li>
				<li>個人情報の開示・訂正、追加または削除、利用停止等の個人情報に関するお問い合わせ先は以下となります。<br/>
					連絡先：0120-001-219（イオンお買物アプリ運営事務局）</li>
			</ol>

			<h2 className={styles.policyBox_tit_l}>第15条（イオングループ企業における本アプリの利用）</h2>
			<p className={styles.policy_txt}>利用者がイオングループ企業の運営する店舗において本アプリを利用される場合には、原則として、本規約に定める事項のうち本サービスに関するものは当該イオングループ企業において完結します。</p>

			<h2 className={styles.policyBox_tit_l}>第16条（プライバシーポリシー）</h2>
			<p className={styles.policy_txt}>利用者による本アプリの利用に関連して当社が知り得る利用者の情報の管理および取扱いについては、当社が別途定める下記URL記載のプライバシーポリシーに従って適切に取扱います。</p>
			{
				(() => {
					if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
					return(
						<div className={styles.policy_linkBtn} onClick={()=>{okaimonoAPI_openBrowser('https://www.aeonretail.jp/privacy/')}}>https://www.aeonretail.jp/privacy/</div>
					)
					} else { //iAEON無効
					return (
						<a href="https://www.aeonretail.jp/privacy/" target="_blank" className={styles.policy_linkBtn}>https://www.aeonretail.jp/privacy/</a>
					)
					}
				})()
			}

			<h2 className={styles.policyBox_tit_l}>第17条（準拠法）</h2>
			<p className={styles.policy_txt}>本規約の成立、効力、履行および解釈に関しては日本国法が適用されるものとします。</p>

			<h2 className={styles.policyBox_tit_l}>第18条（合意管轄）</h2>
			<p className={styles.policy_txt}>本規約に関して紛争が生じた場合、東京地方裁判所を民事調停および第一審の専属的合意管轄裁判所とします。<br/><br/>
			2025年10月7日施行</p>
		</div>

	</div>

	</>
)
}
